/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Animation_Real_Tree_TitleInputs */

const en_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your focus into <span style="@@">real trees</span> on Plus.`)
};

const ar_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حوّل تركيزك إلى <span style="@@">أشجار حقيقية</span> على بلس.`)
};

const de_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richten Sie Ihren Blick auf <span style="@@">echte Bäume</span> auf Plus.`)
};

const es_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte tu concentración en <span style="@@">árboles reales</span> en Plus.`)
};

const fr_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez votre concentration en de <span style="@@">véritables arbres</span> avec Forest Plus`)
};

const it_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma la tua concentrazione in <span style="@@">alberi veri</span> su Plus.`)
};

const ja_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusで集中時間を<span style="@@">本物の木</span>に変えよう`)
};

const ko_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus에서 집중을 <span style="@@">실제 나무</span>로 바꿔 보세요.`)
};

const pt_br_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme seu foco em <span style="@@">árvores de verdade</span> com o Plus.`)
};

const ru_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превратите свою концентрацию в <span style="@@">настоящие деревья</span> вместе с Plus.`)
};

const th_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนการโฟกัสของคุณให้กลายเป็น<span style="@@">ต้นไม้จริง</span>ด้วย Plus`)
};

const tr_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı Plus'ta <span style="@@">gerçek ağaçlara</span> çevir.`)
};

const zh_cn_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级 Plus，
用专注<span style="@@">为地球种树</span>`)
};

const zh_tw_feature_animation_real_tree_title = /** @type {(inputs: Feature_Animation_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升級 Plus，
用專注<span style="@@">為地球種樹</span>`)
};

/**
* | output |
* | --- |
* | "Turn your focus into <span style=\"@@\">real trees</span> on Plus." |
*
* @param {Feature_Animation_Real_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const feature_animation_real_tree_title = /** @type {((inputs?: Feature_Animation_Real_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Animation_Real_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_feature_animation_real_tree_title(inputs)
	if (locale === "ar") return ar_feature_animation_real_tree_title(inputs)
	if (locale === "de") return de_feature_animation_real_tree_title(inputs)
	if (locale === "es") return es_feature_animation_real_tree_title(inputs)
	if (locale === "fr") return fr_feature_animation_real_tree_title(inputs)
	if (locale === "it") return it_feature_animation_real_tree_title(inputs)
	if (locale === "ja") return ja_feature_animation_real_tree_title(inputs)
	if (locale === "ko") return ko_feature_animation_real_tree_title(inputs)
	if (locale === "pt_br") return pt_br_feature_animation_real_tree_title(inputs)
	if (locale === "ru") return ru_feature_animation_real_tree_title(inputs)
	if (locale === "th") return th_feature_animation_real_tree_title(inputs)
	if (locale === "tr") return tr_feature_animation_real_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_feature_animation_real_tree_title(inputs)
	return zh_tw_feature_animation_real_tree_title(inputs)
});